/* eslint-disable */
import React from "react";
import { Link } from "react-router-dom";

import { assetImages } from "constants";
import { useTranslation } from "react-i18next";
import * as url from "helper/UrlHelper";

const JobCard = ({ job }) => {
  const { t } = useTranslation();

  return (
    <div className="event_slideItem w-auto">
      <div className="event_slideInnr">
        <div className="event_hdng">
          <h3>{job.name?.slice(0, 40)}</h3>
          <h5>
            <i className="material-icons-outlined"> event_note </i>
            <span>{job.createddate}</span>
          </h5>
        </div>
        <div className="event_tags">
          <ul className="list_stye_none">
            <li>
              <i className="material-icons-outlined ornge_icon">star</i>
              <span className="rating d-flex gap-1">
                {job.ratingtotal} <em>({job.reviewtotal})</em>
              </span>
            </li>
            <li className="event_loc">
              <i className="material-icons-outlined">place</i>
              <span>
                {job.city}
                {job.city && job.country ? ", " : ""}
                {job.country}
              </span>
            </li>
          </ul>
        </div>
        <div className="event_para">
          <p>{job.summary?.slice(0, 60)}</p>
        </div>
        <div className="event_user grps_user">
          <ul className="list_stye_none">
            <li>
              <Link to="#">
                <img
                  height={40}
                  width={40}
                  className="rounded-circle"
                  src={
                    job.companylogopath == ""
                      ? assetImages.defaultUser
                      : url.SERVER_URL + job.companylogopath
                  }
                  alt=""
                />
              </Link>
            </li>
            <li>
              <Link to="#">{job.companynamestring?.slice(0, 20)}</Link>
            </li>
          </ul>
        </div>
        <div className="mt-2 text-center">
          <Link to={`/jobs/details/${job._id}`}>
            {t("View Details")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default JobCard;
